module.exports = __webpack_public_path__ + "media/images/for-company-bg-03af710b59256e6ee39468d825ac67c7.png";